import { displayDate } from "~/plugins/functions/display";

export interface IModelPermissionResponse {
  id: number;
  name: string;
  permission: string;
  status: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  applicationId: number;
}

export class ModelPermission {
  id: number;
  name: string;
  permission: string;
  status: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  applicationId: number;
  displayCreatedAt: string;
  displayUpdatedAt: string;

  constructor(data: IModelPermissionResponse) {
    this.id = data.id;
    this.name = data.name;
    this.permission = data.permission;
    this.status = data.status;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.applicationId = data.applicationId;
    this.displayCreatedAt = displayDate(this.createdAt);
    this.displayUpdatedAt = displayDate(this.updatedAt);
  }
}
